import React from 'react';
import IconButton from '@mui/material/IconButton';
import DoDisturbAltIcon from '@mui/icons-material/DoDisturbAlt';
import { Tooltip } from 'framework/ui/mui-builder';
import { DeleteButton } from 'framework/ui/ui-builder';
import useLeaveService from 'domain/people/leave/shared/leaveService';
import { LEAVE_CANCEL } from 'domain/shared/leave';
import { LeaveDto } from 'domain/shared/leave';

const RejectLeaveIconButton = ({ leave, isVisible }: { leave: LeaveDto; isVisible?: boolean }) => {
  const { rejectById } = useLeaveService();

  if (isVisible === false) {
    return null;
  }

  return (
    <DeleteButton
      sx={{ p: 0 }}
      deleteMethod={() => rejectById(leave.id!)}
      modalConfirmButtonText="Cancel request"
      key="reject-leave"
      buttonTag={IconButton}
      permissionToCheck={LEAVE_CANCEL}
      buttonText={
        <Tooltip title="Cancel request">
          <DoDisturbAltIcon fontSize="small" color="error" />
        </Tooltip>
      }
      afterDelete={{
        successMessage: 'The Leave request will be canceled. It may take up to 2 days.',
        errorMessage: 'This Leave request cannot be canceled.',
      }}
      displayMessage="Are you sure you want to cancel this leave request? This action cannot be undone."
    />
  );
};

export default RejectLeaveIconButton;
